import React from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const industriesData = [
  {
    id: 1,
    title: "Core HR",
    desc: "Employee Management Organization Structure Employee Documents Employee Profiles",
    image: "/assets/hrms/item1.png"
  },
  {
    id: 2,
    title: "Workforce Management ",
    desc: "Attendance Leave Shift Management Holiday Calendar",
    image: "/assets/hrms/item2.png"
  },
  {
    id: 3,
    title: "Payroll",
    desc: "Payroll Processing Salary Management Payslips Payroll Adjustments",
    image: "/assets/hrms/item3.png"
  },
  {
    id: 4,
    title: "Talent Management",
    desc: "Recruitment Performance Reviews Decision Reviews",
    image: "/assets/hrms/item4.png"
  },
  {
    id: 5,
    title: "Administration",
    desc: "Asset Management Roles & Permissions Reports System Configuration",
    image: "/assets/hrms/item5.png"
  },
];

const IndustriesSliderSection = () => {
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      initial: 0,
      loop: true,
      slides: {
        perView: 1,
        spacing: 24,
      },
      breakpoints: {
        "(min-width: 1024px)": {
          slides: { perView: 2, spacing: 32 },
        },
      },
    },
    [
      (slider) => {
        let timeout;
        let mouseOver = false;
        function clearNextTimeout() {
          clearTimeout(timeout);
        }
        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          timeout = setTimeout(() => {
            slider.next();
          }, 4000);
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
      },
    ]
  );

  return (
    <section className="w-full bg-[#FFFFFF] pb-[80px] lg:pb-[100px] select-none overflow-hidden relative z-10 text-left">
      <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px] flex flex-col gap-12">
        <div>
          <h2 className="text-[#01386A] font-sora font-[600] text-[20px] lg:text-[30px] tracking-tight">
            Core Features
          </h2>
          <p className="font-[500] font-graphik text-[14px] lg:text-[16px] lg:leading-[28px] leading-[22px] text-[#49577A] max-w-[531px] w-full">We focus on creating real, positive impact for our customers, the industries we work with, and the communities around us.
          </p>
        </div>

        <div className="relative w-full">
          <div ref={sliderRef} className="keen-slider overflow-visible">
            {industriesData.map((item) => {
              return (
                <div key={item.id} className="keen-slider__slide py-2">
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 border border-[#BAC9D7] bg-[#FFFFFF] overflow-hidden group min-h-[320px] relative">

                    <div className="w-full h-[200px] sm:h-full overflow-hidden relative">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-center transform transition-transform duration-700 ease-out group-hover:scale-105"
                      />
                    </div>

                    <div className="w-full p-6 sm:p-8 flex flex-col justify-between text-left bg-white relative">

                      <div className="w-full">
                        <h3 className="text-[#01386A] font-sora font-[600] text-[16px] sm:text-[20px] leading-tight mb-2">
                          {item.title}
                        </h3>

                      </div>

                      <div className="w-full overflow-hidden max-h-[200px] transition-all duration-500 ease-in-out">
                        <p className="text-[#49577A] font-graphik text-[14px] sm:text-[16px] leading-relaxed font-[500] pt-2">
                          {item.desc}
                        </p>
                      </div>
                      {/* <div className="w-full mt-auto pt-4 overflow-hidden max-h-[50px] opacity-100 group-hover:opacity-0 group-hover:max-h-0 transition-all duration-400 ease-in-out">
                        <div className="flex items-center gap-1.5 cursor-pointer">
                          <span className="text-[#01386A] font-sora font-[600] text-[14px] hover:underline">
                            Read More
                          </span>
                          <span className="text-[#EA6B24] font-[700] text-[14px] translate-y-[0.5px]">
                            &gt;
                          </span>
                        </div>
                      </div> */}

                    </div>

                    <div className="absolute left-0 bottom-0 h-[3px] w-0 bg-[#EA6B24] transition-all duration-500 ease-out group-hover:w-full z-20" />

                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex items-center gap-4 mt-4 justify-start">
          <button
            onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
            className="w-[32px] h-[32px] rounded-full border border-[#EA6B24] flex items-center justify-center text-[#EA6B24] bg-transparent hover:bg-[#EA6B24] hover:text-white transition-all duration-300 cursor-pointer outline-none"
          >
            <ArrowLeft size={18} strokeWidth={2.5} />
          </button>
          <button
            onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
            className="w-[32px] h-[32px] rounded-full border border-[#EA6B24] flex items-center justify-center text-[#EA6B24] bg-transparent hover:bg-[#EA6B24] hover:text-white transition-all duration-300 cursor-pointer outline-none"
          >
            <ArrowRight size={18} strokeWidth={2.5} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default IndustriesSliderSection;